"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SheetTop = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("./styles");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const VARIANT = {
  PRIMARY: 'primary',
  PRIMARY_LIGHT: 'primaryLight',
  PRIMARY_DARK: 'primaryDark',
  SECONDARY: 'secondary',
  SECONDARY_LIGHT: 'secondaryLight',
  SECONDARY_DARK: 'secondaryDark',
  DARK: 'dark',
  LIGHT: 'light',
  SEPIA: 'sepia'
};
const SheetTop = _ref => {
  let {
    children,
    label,
    startIcon,
    color,
    accessbilityAction,
    accessbilityLabel
  } = _ref;
  const classes = (0, _styles.useStyles)();
  const [showing, setShowing] = (0, _react.useState)(false);
  const computedClassName = () => {
    switch (color) {
      case VARIANT.PRIMARY:
        return classes.primaryVariant;
      case VARIANT.PRIMARY_LIGHT:
        return classes.primaryLightVariant;
      case VARIANT.PRIMARY_DARK:
        return classes.primaryDarkVariant;
      case VARIANT.SECONDARY:
        return classes.secondaryVariant;
      case VARIANT.SECONDARY_LIGHT:
        return classes.secondaryLightVariant;
      case VARIANT.SECONDARY_DARK:
        return classes.secondaryDarkVariant;
      default:
        return '';
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([classes.root, computedClassName()]),
    style: {
      backgroundColor: (0, _utils.checkSheetColor)(color)
    },
    onMouseEnter: () => setShowing(true),
    onMouseLeave: () => setShowing(false)
  }, accessbilityAction && /*#__PURE__*/_react.default.createElement("button", {
    style: {
      height: '0px',
      width: '0px',
      padding: 0,
      margin: 0,
      position: 'absolute',
      overflow: 'hidden',
      border: 'none'
    },
    onClick: accessbilityAction,
    type: "button",
    "aria-label": accessbilityLabel
  }, accessbilityLabel), showing && /*#__PURE__*/_react.default.createElement("div", {
    "aria-hidden": true,
    className: classes.children
  }, children), /*#__PURE__*/_react.default.createElement("p", {
    "aria-hidden": true,
    className: classes.title,
    style: {
      color: (0, _utils.checkTextColor)(color)
    }
  }, startIcon && startIcon, " ", label));
};
exports.SheetTop = SheetTop;
SheetTop.propTypes = {
  /**
   * Conteúdo do componente
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Cor do botão
   */
  label: _propTypes.default.string.isRequired,
  /**
   * Ícone que aparecerá antes do texto
   */
  startIcon: _propTypes.default.node,
  /**
   * Cor do botão
   */
  color: _propTypes.default.oneOf(['primary', 'primaryLight', 'primaryDark', 'secondary', 'secondaryLight', 'secondaryDark', 'light', 'dark', 'sepia']),
  /** Ação que será executada ao acionar o botão de acessibilidade, acessado
   * via TAB e leitores de tela.
   * Essa propriedade deve ser preenchida para exibir o comportamento de
   * acessibilidade
   */
  accessbilityAction: _propTypes.default.func,
  /**
   * o texto que sera atrelado ao botão de acessibilidade
   */
  accessbilityLabel: _propTypes.default.string
};
SheetTop.defaultProps = {
  startIcon: null,
  color: 'secondary',
  accessbilityAction: undefined,
  accessbilityLabel: ''
};
var _default = exports.default = SheetTop;